// import IEmployee from "../models/Employee";
// import IFeedback from "../models/Feedback";
// import IGoals from "../models/Goals";
// import IReview from "../models/Reviews";
import IEmployee from "models/Employee";
import IFeedback from "models/Feedback";
import IGoals from "models/Goals";
// import IReviewsss from "models/Reviews";
// import IReview from "models/Reviews";

export const avatars = [
  {
    id: 1,
    name: "Cindy Baker",
    alt: "Cindy Baker",
    src: "https://plus.unsplash.com/premium_photo-1688350808212-4e6908a03925?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 2,
    name: "Martin Shiv",
    alt: "Martin Shiv",
    src: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 3,
    name: "Aman Kumar",
    alt: "Aman Kumar",
    src: "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 4,
    name: "Morenna Mbounja",
    alt: "Morenna Mbounja",
    src: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGF2YXRhcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 5,
    name: "Hanfried Nguegan",
    alt: "Hanfried Nguegan",
    src: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGF2YXRhcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",
  },
];

export const feedbackMockData: IFeedback[] = [
  {
    id: 1,
    name: "Olivia Bennett",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGF2YXRhcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",
    title: "Great job on the latest feature implementation",
    feedback:
      "Great job on the latest feature implementation! Your code is clean and well-organized.",
    date: "8 hours ago",
  },
  {
    id: 2,
    name: "Morenna Mbounja",
    avatar:
      "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
    title: "Great job on the latest feature implementation",
    feedback:
      "Your attention to detail is impressive. You caught several bugs during code reviews, ensuring a high-quality release.",
    date: "04 Nov 2022",
  },
  {
    id: 3,
    name: "Ethan Parker",
    avatar:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGF2YXRhcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",
    title: "Great job on the latest feature implementation",
    feedback: "I appreciate your proactive approach to problem-solving.",
    date: "8 hours ago",
  },
  {
    id: 4,
    name: "Marc Phillips",
    avatar:
      "https://plus.unsplash.com/premium_photo-1682095643806-79da986ccf8d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fGF2YXRhcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",
    title: "Great job on the latest feature implementation",
    feedback:
      "Your communication skills could use some improvement. Providing more frequent updates and clarifying technical concepts would be beneficial for the team.",
    date: "8 hours ago",
  },
  {
    id: 5,
    name: "Hanfried Nguegan",
    avatar:
      "https://plus.unsplash.com/premium_photo-1664536392779-049ba8fde933?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
    title: "Great job on the latest feature implementation",
    feedback:
      "You've shown a strong understanding of design patterns and best practices, resulting in a scalable and efficient codebase.",
    date: "8 hours ago",
  },
  {
    id: 6,
    name: "Lydie Rose",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGF2YXRhcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",
    title: "Great job on the latest feature implementation",
    feedback:
      "While your code works, there is room for optimization. Consider refactoring certain sections to improve performance and readability",
    date: "8 days ago",
  },
  {
    id: 7,
    name: "Pascal Nguegan",
    avatar:
      "https://images.unsplash.com/photo-1632922267756-9b71242b1592?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8ODN8fGF2YXRhcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",

    title: "Great job on the latest feature implementation",
    feedback:
      "Your willingness to seek feedback and collaborate with others is commendable. It has fostered a positive team environment.",
    date: "08 Nov 2022",
  },
];

export const members = [
  {
    id: 1,
    name: "Francis Hanfried",
    avatar:
      "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 2,
    name: "Lydie Rose",
    avatar:
      "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
  },
  {
    id: 3,
    name: "Morenna Mbounja",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGF2YXRhcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",
  },
];

export const strategicDomainOptions = [
  "Financial",
  "People",
  "Customer",
  "Process",
];

export const positionOptions = [
  "Software Engineer",
  "Frontend Developer",
  "Backend Developer",
  "Quality & Assurance",
  "UI/UX Designer",
  "Financial Analyst",
  "Product Manager",
  "Scrum Master",
  "HR Officer"
];

export const departmentOptions = [
  "IT",
  "SALES",
  "FINANCE",
  "OPERATIONS",
];

export const roleOptions = ["User","Manager","Administrator"];

export const employees: IEmployee[] = [
  {
    id: "1",
    avatar:
      "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
    firstName: "Jenny",
    lastName: "Christelle",
    username: "Jenny Christelle",
    password: "Jennychristelle1",
    phoneNumber: "+236 699745270",
    address: "Bonaberi",
    gender: "Male",
    managerName: "Melaine Lapa",
    jobTitle: "Software Engineer",
    department: "Engineering",
    role: ["Manager"],
    email: "jennychristelle@mavianceplc.cm",
  },
  {
    id: "2",
    avatar:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGF2YXRhcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",
    firstName: "Jane",
    lastName: "Smith",
    username: "Jane Smith",
    password: "Janesmith1",
    phoneNumber: "+236 699745270",
    address: "Bonaberi",
    gender: "Female",
    managerName: "Melaine Lapa",
    managerAvatar: "",
    jobTitle: "Software Engineer",
    department: "Engineering",
    role: ["Employee"],
    email: "janesmith@mavianceplc.cm",
  },
  {
    id: "3",
    avatar:
      "https://plus.unsplash.com/premium_photo-1688891564708-9b2247085923?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
    firstName: "Michael",
    lastName: "Johnson",
    username: "Michael Johnson",
    password: "Michaeljohnson1",
    phoneNumber: "+236 699745270",
    address: "Bonaberi",
    gender: "Male",
    managerName: "Melaine Lapa",
    jobTitle: "Software Engineer",
    department: "Engineering",
    role: ["Employee"],
    email: "michaeljohnson@mavianceplc.cm",
  },
  {
    id: "4",
    avatar:
      "https://plus.unsplash.com/premium_photo-1688740375397-34605b6abe48?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fGF2YXRhcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",
    firstName: "Emily",
    lastName: "Davis",
    username: "Emily Davis",
    password: "Emilydavis1",
    phoneNumber: "+236 699745270",
    address: "Bonaberi",
    gender: "Female",
    managerName: "Melaine Lapa",
    jobTitle: "Software Engineer",
    department: "Engineering",
    role: ["Manager"],
    email: "emilydavis@mavianceplc.cm",
  },
  {
    id: "5",
    avatar:
      "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
    firstName: "Robert",
    lastName: "Brown",
    username: "Robert Brown",
    password: "Robertbrown1",
    phoneNumber: "+236 699745270",
    address: "Bonaberi",
    gender: "Male",
    managerName: "Melaine Lapa",
    jobTitle: "Software Engineer",
    department: "Engineering",
    role: ["Employee"],
    email: "robertbrown@mavianceplc.cm",
  },
  {
    id: "6",
    avatar:
      "https://plus.unsplash.com/premium_photo-1688350808212-4e6908a03925?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
    firstName: "Sophia",
    lastName: "Lee",
    username: "Sophia Lee",
    password: "Sophialee1",
    phoneNumber: "+236 699745270",
    address: "Bonaberi",
    gender: "Female",
    managerName: "Melaine Lapa",
    jobTitle: "Software Engineer",
    department: "Engineering",
    role: ["Manager"],
    email: "sophialee@mavianceplc.cm",
  },
  {
    id: "7",
    avatar:
      "https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
    firstName: "William",
    lastName: "Clark",
    username: "William Clark",
    password: "Williamclark1",
    phoneNumber: "+236 699745270",
    address: "Bonaberi",
    gender: "Male",
    managerName: "Melaine Lapa",
    jobTitle: "Software Engineer",
    department: "Engineering",
    role: ["Employee"],
    email: "williamclark@mavianceplc.cm",
  },
  {
    id: "8",
    avatar:
      "https://plus.unsplash.com/premium_photo-1682095643806-79da986ccf8d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fGF2YXRhcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",
    firstName: "Olivia",
    lastName: "Hall",
    username: "Olivia Hall",
    password: "Oliviahall1",
    phoneNumber: "+236 699745270",
    address: "Bonaberi",
    gender: "Female",
    managerName: "Melaine Lapa",
    jobTitle: "Software Engineer",
    department: "Engineering",
    role: ["Employee"],
    email: "oliviahall@mavianceplc.cm",
  },
];

export const goalData: IGoals[] = [
  {
    id: 1,
    strategicDomains: "Financial",
    keyPerformanceArea: "Event Organization",
    objectives:
      "Monitor the optimization of budget during events to ensure 0% over spent for each event",
    avatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
    firstName: "Jenny",
    lastName: "Christelle",
    weight: 5,
  },
  {
    id: 2,
    strategicDomains: "Financial",
    keyPerformanceArea: "Office Supply Acquisition",
    objectives:
      "Monitor the optimization of budget during events to ensure 0% over spent for each event",
    avatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
    firstName: "Jenny",
    lastName: "Christelle",
    weight: 5,
  },
  {
    id: 3,
    strategicDomains: "Customer",
    keyPerformanceArea: "Onboarding and Integration",
    objectives:
      "Enhance on the onboarding process by ensuring 95% satisfactory score after 3 months by new recruits",
    avatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
    firstName: "Jenny",
    lastName: "Christelle",
    weight: 20,
  },
  {
    id: 4,
    strategicDomains: "Process",
    keyPerformanceArea: "Recruitment",
    objectives:
      "Ensure an average recruitment turnaround time of 60 days from advert to onboarding for all positions in 2023",
    avatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
    firstName: "Jenny",
    lastName: "Christelle",
    weight: 15,
  },
  {
    id: 5,
    strategicDomains: "People",
    keyPerformanceArea: "Learning and Development",
    objectives:
      "Collect and build a Training Plan for staff by August 2023. Rollout 90% of plan in the course of the year.",
    avatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
    firstName: "Jenny",
    lastName: "Christelle",
    weight: 12,
  },
];

// export const reviewFormData:IReviewsss[] = [
//   {
//     id: 1,
//     author: "Jenny Christelle", // The person's Manager
//     formName: "Manager Assessment Form",
//     authorAvatar:"https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
//     signer: "Olivia Hall",
//     signerAvatar: "https://plus.unsplash.com/premium_photo-1682095643806-79da986ccf8d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzV8fGF2YXRhcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",
//     authorDueDate: "September 24, 2022 5:00 pm",
//     signerDueDate: "October 9, 2022 4:00 pm",
//     status: "Completed",
//   },
//   {
//     id: 2,
//     author: "Jenny Christelle", // The person's Manager
//     formName: "Manager Assessment Form",
//     authorAvatar:"https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
//     signer: "William Clark",
//     signerAvatar: "https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
//     authorDueDate: "September 24, 2022 5:00 pm",
//     signerDueDate: "October 9, 2022 4:00 pm",
//     status: "Pending",
//   },
//   {
//     id: 3,
//     author: "Jenny Christelle", // The person's Manager
//     formName: "Manager Assessment Form",
//     authorAvatar:"https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
//     signer: "Robert Brown",
//     signerAvatar: "https://plus.unsplash.com/premium_photo-1688740375397-34605b6abe48?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fGF2YXRhcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",
//     authorDueDate: "September 24, 2022 5:00 pm",
//     signerDueDate: "October 9, 2022 4:00 pm",
//     status: "Approved",
//   },
//   {
//     id: 4,
//     author: "Jenny Christelle", // The person's Manager
//     formName: "Manager Assessment Form",
//     authorAvatar:"https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
//     signer:"Jane Smith",
//     signerAvatar:"https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGF2YXRhcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60",
//     authorDueDate: "September 24, 2022 5:00 pm",
//     signerDueDate: "October 9, 2022 4:00 pm",
//     status: "Completed",
//   },
//   {
//     id: 5,
//     author:"Jenny Christelle", // The person's Manager
//     formName: "Manager Assessment Form",
//     authorAvatar:"https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
//     signer:"Michael Johnson",
//     signerAvatar:"https://plus.unsplash.com/premium_photo-1688891564708-9b2247085923?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=500&q=60",
//     authorDueDate: "September 24, 2022 5:00 pm",
//     signerDueDate: "October 9, 2022 4:00 pm",
//     status: "Pending",
//   }
// ]

